import React from 'react';

import { Image } from 'components/Image';

export const MakeTalentEfficient = () => {
  return (
    <div className="use-case-background">
      <Image
        imagePath="homepage/make-talent-management.png"
        alt="Illustration picture for the use case Cultivate Cost Efficiency"
        loading="lazy"
      />
    </div>
  );
};
